export default __webpack_public_path__ + "static/media/h-portfolio-pvn.d6be6ea4.webp";